/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { MigrateOrganizationManagerProcessResponse } from './';
import {
    MigrateOrganizationManagerProcessResponseFromJSON,
    MigrateOrganizationManagerProcessResponseFromJSONTyped,
    MigrateOrganizationManagerProcessResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface MigrateOrganizationManagersResponse
 */
export interface MigrateOrganizationManagersResponse {
    /**
     * 
     * @type {number}
     * @memberof MigrateOrganizationManagersResponse
     */
    acceptedCounter: number;
    /**
     * 
     * @type {Array<MigrateOrganizationManagerProcessResponse>}
     * @memberof MigrateOrganizationManagersResponse
     */
    lineResults: Array<MigrateOrganizationManagerProcessResponse>;
}

/**
 * Check if a given object implements the MigrateOrganizationManagersResponse interface.
 */
export function instanceOfMigrateOrganizationManagersResponse(value: object): value is MigrateOrganizationManagersResponse {
    if (!('acceptedCounter' in value) || value['acceptedCounter'] === undefined) return false;
    if (!('lineResults' in value) || value['lineResults'] === undefined) return false;
    return true;
}

export function MigrateOrganizationManagersResponseFromJSON(json: any): MigrateOrganizationManagersResponse {
    return MigrateOrganizationManagersResponseFromJSONTyped(json, false);
}

export function MigrateOrganizationManagersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MigrateOrganizationManagersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'acceptedCounter': json['acceptedCounter'],
        'lineResults': ((json['lineResults'] as Array<any>).map(MigrateOrganizationManagerProcessResponseFromJSON)),
    };
}

export function MigrateOrganizationManagersResponseToJSON(value?: MigrateOrganizationManagersResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'acceptedCounter': value['acceptedCounter'],
        'lineResults': ((value['lineResults'] as Array<any>).map((v) => MigrateOrganizationManagerProcessResponseToJSON(v))),
    };
}

